import React, { useRef, useState } from 'react';

import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import axios from 'axios';
import {
    validaSoloNumero, formatMoneda, validaMonto, formatoMonto, seleccionarCampo
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import CatalogoCuentasAsientos from '../../catalogos/catalogoCuentaAsientos';
import { Dimmer } from '../spinner';


export const ModalIncluirCuenta = (props) => {

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../src/modulos/datos');
    let anio = JSON.parse(localStorage.getItem('anioactu'))
    const fechasistema = moment.utc(JSON.parse(localStorage.getItem('fechasistema'))).format('YYYY-MM-DD');
    const deshabilitado = false;

    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    /*  variables de referencias */
    const txtDebe = useRef();
    const txtHaber = useRef();
    const txtCuentaContable = useRef();
    const txtDescripcion = useRef();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtObserStatus = useRef();
    const txtId = useRef();

    /*  variables de estados */
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mostrar, setMostrar] = useState(false)
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [observacion, setObservacion] = useState('hidden');
    const [values, setValues] = useState();

    const styleInput = {
        backgroundColor: '#ffff',
        color: '#444242'
    }

    const styleInputDirec = {
        backgroundColor: '#ffff',
        color: '#444242',
        height: 50,

    }


    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        /* if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        } */


        // Devuelve el número formateado
        if (event.which === 13 || typeof event.which === "undefined") {
            /* let e = event.target.value.replace(/\D/g, "")
                .replace(/([0-9])([0-9]{2})$/, '$1.$2')
                .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

            return formatMoneda(e) */
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.target.id === "montodebe") {
                if (event.which === 13) {
                    txtHaber.current.focus();
                }
            } else if (event.target.id === "montohaber") {
                if (event.which === 13) {
                    btnAcepta.current.focus();
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;

    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        let columna;
        var sigue = true;
        if (operacion === 1 || operacion === 2) {
            if (txtId.current.value.trim() === '') {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Alguna Cuenta.', icono: 'informacion' });
                txtId.current.focus();
                sigue = false;

            } else if (txtDebe.current.value.trim() === '') {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Monto del Debe.', icono: 'informacion' });
                txtDebe.current.focus();
                sigue = false;

            } else if (txtHaber.current.value.trim() === '') {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Monto del Haber.', icono: 'informacion' });
                txtHaber.current.focus();
                sigue = false;

            } else if (parseInt(txtDebe.current.value.trim()) > 0 && parseInt(txtHaber.current.value.trim()) > 0) {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Debe o el Haber de ingresarse en 0,00 a comparación del otro.', icono: 'informacion' });
                txtHaber.current.value = 0;
                txtHaber.current.focus();
                sigue = false;

            }



        }

        if (parseInt(props.tabla) === 0) {
            columna = {

                idplancuenta: values.idplancuenta,
                codigocuenta: txtCuentaContable.current.value,
                descripcion: txtDescripcion.current.value,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                idcuentacontable: values.idcuentacontable

            }
        } else {
            columna = {

                idplancuenta: values.idplancuenta,
                codigocuenta: txtCuentaContable.current.value,
                descripcion: txtDescripcion.current.value,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                idcuentacontable: parseInt(txtId.current.value),

            }
        }



        if (sigue && !props.estadoboton) {

            props.cargarTabla(columna)

        } else if (sigue && props.estadoboton) {

            let msg = '';
            if (operacion === 1) {
                msg = 'Esta Seguro de Registrar estos Datos.';
            } else if (operacion === 2) {
                msg = 'Esta Seguro de Modificar estos Datos.';
            } else if (operacion === 3) {
                msg = 'Esta Seguro de Eliminar estos Datos.';
            }

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });

        }

    }

    const procesarRegistro = () => {
        setActivate(true);
        let endpoint;
        let body;



        if (operacion === 1) {

            endpoint = `${op.conexion}/api/contabilidad/asientocrear`;

            body = {


                cuenta: values.codigocuenta,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                efiscal: parseInt(idefiscal),
                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
                fechaMov: fechasistema,
                idasiento: parseInt(props.asientoId),
                tipo: parseInt(props.tabla)


            }


        } else if (operacion === 2) {

            endpoint = `${op.conexion}/api/contabilidad/asientomodificar`;

            body = {

                cuenta: values.codigocuenta,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                efiscal: parseInt(idefiscal),
                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
                fechaMov: fechasistema,
                idasiento: parseInt(props.asientoId),
                idmovimiento: parseInt(props.idmovi)

            }

        } else if (operacion === 3) {

            endpoint = `${op.conexion}/api/contabilidad/asientoeliminar`;

            body = {

                cuenta: values.codigocuenta,
                efiscal: parseInt(idefiscal),
                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
                idasiento: parseInt(props.asientoId),
                idmovi: parseInt(props.idmovi)

            }


        }



        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {
                if (props.operacion === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
                } else if (props.operacion === 2) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
                } else if (props.operacion === 3) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
                }

                setActivate(false);
            }
        }).catch(function (error) {
            let mensaje = '';
            if (error.response === undefined) {
                mensaje = 'Error de Conexion'
            } else {
                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
                    mensaje = 'Ya existe un Registro con este rif'

                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
                    mensaje = 'Ya existe un Registro con este correo'
                }
                else {
                    mensaje = error.response.data.message
                }
            }
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);
        })
    }

    const blanquear = () => {
        setActivate(false);
        txtId.current.value = ''
        txtCuentaContable.current.value = '';
        txtDescripcion.current.value = '';
        txtDebe.current.value = '';
        txtHaber.current.value = '';
        setOperacion(0);

    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();
    };

    const cancelar = (e) => {
        e.preventDefault();
        let columna;



        if (props.estadoboton) {

            columna = {

                idplancuenta: parseInt(txtId.current.value),
                codigocuenta: txtCuentaContable.current.value,
                descripcion: txtDescripcion.current.value,
                debe: txtDebe.current.value,
                haber: txtHaber.current.value,
                idcuentacontable: values.idcuentacontable ? values.idcuentacontable : ''

            }
            props.cargarTabla(columna)
        } else {
            props.onHideCancelar();

        }





    }

    /* valdar buscador por numero cedula */
    const validarCuenta = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        txtDescripcion.current.value = '';
        txtCuentaContable.current.value = '';
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarCuenta(event.target.value, event.which);
            }
        }
    };

    const seleccionarCuenta = (id, tecla) => {
        let endpoint;

        if (parseInt(props.tabla) === 0) {
            let campos = '*';
            let nomtab = 'plancuenta';
            let nomid = 'idplancuenta';
            let nomid2 = 'idefiscal';
            let id2 = idefiscal;

            endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id=${id}&id2=${id2}`;
        } else {
            let campos = "*";

            let nomtab = "cuentacontable";
            let nomid = "idcuentacontable";
            let nomid2 = "idefiscal";
            let nomtab2 = "plancuenta";
            let nomid3 = "idplancuenta";

            endpoint = `${op.conexion}/api/consulta/modeli6?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}&nomtab2=${nomtab2}&nomid3=${nomid3}`;
        }
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {

                if (response.data.length > 0) {
                    let cta = props.tabla === 0 ? response.data[0].idplancuenta : response.data[0].idcuentacontable;
                    let cta1 = 0;
                    for (let i = 0; i < props.cuentas.length; i++) {
                        cta1 = props.tabla === 0 ? props.cuentas[i].idplancuenta : props.cuentas[i].idcuentacontable;
                        if (parseInt(cta) === parseInt(cta1)) {
                            if (props.operacion === 1) {
                                setActivate(false);
                                txtId.current.value = "";
                                txtCuentaContable.current.value = "";
                                txtDescripcion.current.value = "";
                                setMensaje({
                                    mostrar: true,
                                    titulo: "Notificación",
                                    texto: "Esta Cuenta ya se encuentra Agregada.",
                                    icono: "informacion",
                                });
                                

                                return;
                            } 
                        }
                    }
                    setValues(response.data[0]);
                    txtId.current.value = props.tabla === 0 ? response.data[0].idplancuenta : response.data[0].idcuentacontable;
                    txtCuentaContable.current.value = response.data[0].codigocuenta !== null ? response.data[0].codigocuenta : '';
                    txtDescripcion.current.value = response.data[0].descripcion !== null ? response.data[0].descripcion : '';
                    if (tecla === 13) {
                        txtDebe.current.focus();
                    }
                    setActivate(false);
                } else {
                    txtId.current.value = '';
                    txtCuentaContable.current.value = '';
                    txtDescripcion.current.value = '';
                    setMensaje({
                        mostrar: true,
                        titulo: "Notificación",
                        texto: "LA CUENTA NO EXISTE.",
                        icono: "informacion",
                    });

                }
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };


    const onHideAceptaCatalogo = (values) => {
        setValues(values)
        txtId.current.value = props.tabla === 0 ? values.idplancuenta : values.idcuentacontable;
        /* txtCuentaContable.current.value = values.codigocuenta;
        txtDescripcion.current.value = values.descripcion; */
        seleccionarCuenta(props.tabla === 0 ? values.idplancuenta : values.idcuentacontable);
        setMostrar(false);
    }

    const cerrarModal = () => {
        props.renderizar(props.asientoId);
        props.onHideCancelar();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();

    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion)


                if (props.operacion !== 1) {

                    setValues(props.cuentaContable);
                    //seleccionarCuenta(props.tabla === 0 ? props.cuentaContable.idplancuenta : props.cuentaContable.idcuentacontable);
                    txtId.current.value = props.cuentaContable.idcuentacontable > 0 ? props.cuentaContable.idcuentacontable : props.cuentaContable.idplancuenta;
                    txtCuentaContable.current.value = props.cuentaContable.codigocuenta;
                    txtDescripcion.current.value = props.cuentaContable.descripcion;
                    txtDebe.current.value = formatMoneda(parseFloat(props.cuentaContable.debe).toString().replace(",", "").replace(".", ","), ",", ".", 2);
                    txtHaber.current.value = formatoMonto(parseFloat(props.cuentaContable.haber).toString().replace(",", "").replace(".", ","), ",", ".", 2);

                } else {
                    txtId.current.value = '';
                    txtCuentaContable.current.value = '';
                    txtDescripcion.current.value = '';
                    txtDebe.current.value = '0,00';
                    txtHaber.current.value = '0,00';
                    setValues();

                }
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <Modal.Title style={{ color: "#fff" }}>{props.operacion === 1 ? 'Agregar Cuenta Contable.' : props.operacion === 2 ? 'Editar Cuenta Contable.' : props.operacion === 3 ? 'Eliminar Cuenta Contable.' : 'Consultar Cuenta Contable.'}</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF" }}>


                <div>
                    <div className='w-100 row mx-auto'>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-5">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                            <input type="text" className="form-control text-uppercase" ref={txtId} onKeyUp={validarCuenta} onBlur={validarCuenta} aria-label="Sizing example input" disabled={operacion !== 1 ? true : false} aria-describedby="inputGroup-sizing-sm" />
                            <button type="button" onClick={() => { setMostrar(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>
                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-7">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Cuenta Contable:</label>
                            <input type="text" className="form-control text-uppercase" ref={txtCuentaContable} value={values ? values.codigocuenta !== null ? values.codigocuenta : '' : ''} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-12">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                            <textarea style={{ height: 60 }} className="form-control text-uppercase" ref={txtDescripcion} disabled value={values ? values.descripcion !== null ? values.descripcion : '' : ''} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-6">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto Debe:</label>
                            <input type="text" id="montodebe" className="form-control text-right" disabled={operacion === 4 ? true : operacion === 3 ? true : false} aria-label="Sizing example input" defaultValue="0,00" ref={txtDebe} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputMontoChange} placeholder="0,00" onBlur={handleInputMontoChange} onFocus={seleccionarCampo} />

                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-6">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto Haber:</label>
                            <input type="text" id="montohaber" className="form-control text-right" disabled={operacion === 4 ? true : operacion === 3 ? true : false} aria-label="Sizing example input" ref={txtHaber} defaultValue="0,00" aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputMontoChange} placeholder="0,00" onBlur={handleInputMontoChange} onFocus={seleccionarCampo} />

                        </div>


                    </div>
                    <CatalogoCuentasAsientos
                        show={mostrar}
                        onHideCancelar={() => { setMostrar(false) }}
                        tabla={props.tabla}
                        onHideAceptaCatalogo={onHideAceptaCatalogo}
                    />

                    <Mensaje mensaje={mensaje}
                        onHide={() => {
                            mensaje.titulo === 'Exito.' ?
                                cerrarModal() :
                                setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                        }
                        } />
                    <MensajeSiNo mensaje={mensajesino}
                        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                    <Dimmer active={activate} inverted>

                    </Dimmer>
                </div>
            </Modal.Body >
            <Modal.Footer>
                <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success col-md-3"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-3"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal >
    );
}

